import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromFieldGroup from '../_reducers/fieldGroup';

export const selectFieldGroupState =
  createFeatureSelector<fromFieldGroup.FieldGroupState>('fieldGroups');

export const selectAllFieldGroups = createSelector(selectFieldGroupState, fromFieldGroup.selectAll);

export const selectFieldGroupEntities = createSelector(
  selectFieldGroupState,
  fromFieldGroup.selectEntities
);

export const selectFieldGroupById = (id: number) =>
  createSelector(selectFieldGroupEntities, (entities) => entities[id]);

export const selectFieldGroupTotal = createSelector(
  selectFieldGroupState,
  fromFieldGroup.selectTotal
);
